import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import AnnualTaxesPresenter from "./AnnualTaxesPresenter";
import InputFactory from "../../../components/InputFactory";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import Progress from "../../../components/Progress";

class AnnualTaxesPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AnnualTaxesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      selectedYear: "",
      objects: [],
      year: [],
      limit: 50,
      current: 1,
      count: 0,
    };
  }

  getCollectionName() {
    return "employees";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  _handleYearChange(field, value) {
    this.setState({ [field]: value });
    this.presenter._onChangeFilter("array", value, ["basicTax", "apTax"]);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, progress, count, limit, current, selectedYear } =
      this.state;

    console.log("OBJECTSSS", objects);

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "surname" &&
        fields !== "Middlename" &&
        fields !== "Firstname" &&
        fields !== "basicTax" &&
        fields !== "apTax"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Annual Taxes
                  </span>
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="row">
                    {Object.keys(schema.filters || {})
                      .filter(
                        (field) =>
                          field === "Firstname" ||
                          field === "Middlename" ||
                          field === "surname"
                      )
                      .map((field) => {
                        let { type, ...options } = schema.filters[field];
                        return (
                          <div className="col-lg-4 p-1" key={field}>
                            <InputFactory
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.presenter._onChangeFilter.bind(
                                this,
                                type
                              )}
                              {...options}
                            />
                          </div>
                        );
                      })}
                  </div>
                </CardView>
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center ">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex flex-row align-items-center justify-content-center gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <SearchSelect
                        value={this.state.selectedYear}
                        onChange={(value) =>
                          this._handleYearChange("selectedYear", value)
                        }
                        onClickClear={() =>
                          this._handleYearChange("selectedYear", "")
                        }
                        options={this.presenter
                          ._getYearOptions()
                          .map((payrollYear) => ({
                            label: payrollYear,
                            value: payrollYear,
                          }))}
                        placeholder="Select Year"
                      />
                      <Button
                        onClick={() =>
                          this.presenter._handleExportCsv(includeLabel, objects)
                        }
                      >
                        <i className="bi bi-arrow-down-circle"></i> Export CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      // case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
                selectedItem={selectedYear}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default AnnualTaxesPage;
